import { render, staticRenderFns } from "./ResetPasswordEmail.vue?vue&type=template&id=811c396e&scoped=true"
import script from "./ResetPasswordEmail.vue?vue&type=script&lang=js"
export * from "./ResetPasswordEmail.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordEmail.vue?vue&type=style&index=0&id=811c396e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "811c396e",
  null
  
)

export default component.exports